var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.htmltag,{tag:"component",staticClass:"tag",class:_vm.tagClass},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tag.name)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }